// widgets/location-popover/ui/LocationSavedPopover.tsx

import type { IOrderType, ISavedBranch } from '@/_store/types';
import { Button } from '@/components/ui/button';
import { Box, HStack, Text, VStack } from '@chakra-ui/react';
import { useTranslations } from 'next-intl';
import React from 'react';

type Props = {
  orderType: IOrderType | null;
  branch: ISavedBranch | null;
  address?: string;
  onClose: () => void;
  onOpenSelector: () => void;
  onConfirmSaved: () => void;
};

const SavedAddressPopover: React.FC<Props> = ({
  orderType,
  branch,
  address,
  onClose,
  onOpenSelector,
  onConfirmSaved,
}) => {
  const t = useTranslations();

  return (
    <VStack
      w='320px'
      textAlign='center'
      gap={8}
      bg='background.card'
      color='text'
    >
      <Box>
        <Text>
          {orderType?.type === 'self-pickup'
            ? t('location.order_to_this_branch?')
            : t('location.order_to_this_address?')}
        </Text>

        <Text fontSize='xl' fontWeight={700} lineHeight={1} mt={3}>
          {orderType?.type === 'self-pickup' ? branch?.name : address}
        </Text>
      </Box>

      <HStack w='full'>
        <Button
          flex={1}
          height='56px'
          variant='subtle'
          onClick={onOpenSelector}
        >
          {t('no')}
        </Button>

        <Button
          flex={1}
          bg='primary'
          height='56px'
          color='primary.text'
          _hover={{ bg: 'primary.hover' }}
          onClick={() => {
            onConfirmSaved();
            onClose();
          }}
        >
          {t('yes')}
        </Button>
      </HStack>
    </VStack>
  );
};

export default SavedAddressPopover;
